/* eslint-disable no-underscore-dangle */
import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";

/* Types & Action Creators */

const { Types, Creators } = createActions(
  {
    request: ["params"],
    success: ["data"],
    failure: ["error"],
    roleRequest: ["params"],
    roleSuccess: ["data"],
    roleFailure: ["error"],
    reset: [],
  },
  { prefix: "USER_ROLES_" }
);

export const RolesTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = {
  data: [],
  pagination: null,
  loading: false,
  error: null,
};

/* Reducers */

export const _request = (state) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

export const _success = (state, action) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
    pagination: { $set: action.pagination },
  });

export const _failure = (state, action) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

  export const _roleRequest = (state) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

export const _roleSuccess = (state, action) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
    pagination: { $set: action.pagination },
  });

export const _roleFailure = (state, action) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });



export const _reset = () => INITIAL_STATE;

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: _request,
  [Types.SUCCESS]: _success,
  [Types.FAILURE]: _failure,
  [Types.ROLE_REQUEST]: _roleRequest,
  [Types.ROLE_SUCCESS]: _roleSuccess,
  [Types.ROLE_FAILURE]: _roleFailure,
  [Types.RESET]: _reset,
});
